import Vue from 'vue'
import SystemMessage from './SystemMessage.vue'
import i18n from '@/i18n'
import '@/reset.css'

Vue.config.productionTip = false

new Vue({
  i18n,
  data: {
    page: '404',
  },
  render: h => h(SystemMessage),
}).$mount('#app')
